import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";

export const FormSelect = ({
  label,
  name,
  value,
  onChange,
  options,
  required = false,
}) => (
  <FormControl
    required={required}
    fullWidth
    sx={{
      "& .MuiInputLabel-root": {
        fontSize: "1rem",
        color: "#34495e",
        transition: "color 0.3s ease",
      },
      "& .MuiInputLabel-root.Mui-focused": {
        color: "#1f3a5a",
      },
      "& .MuiOutlinedInput-root": {
        borderRadius: 2,
        transition: "all 0.3s ease",
        "& fieldset": {
          borderColor: "#BDC3C7",
          borderWidth: "1px",
        },
        "&:hover fieldset": {
          borderColor: "#2980b9",
        },
        "&.Mui-focused fieldset": {
          borderColor: "#1f3a5a",
          borderWidth: "2px",
        },
      },
      "& .MuiSelect-select": {
        padding: "12px 14px",
        fontSize: "1rem",
      },
    }}
  >
    <InputLabel>{label}</InputLabel>
    <Select
      name={name}
      value={value}
      onChange={onChange}
      label={label}
      MenuProps={{
        PaperProps: {
          sx: {
            maxHeight: "200px",
            backgroundColor: "white",
            borderRadius: "2px",
          },
        },
      }}
    >
      {options.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
);
